module.exports = __webpack_public_path__ + "img/down.20fd18b4.svg";